// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iCWx","col":"styles_col__2cfXj"};